<!-- 作品案例 -->
<template>
    <div class="wrap">
        <div class="top">
            <h5>作品案例</h5>
            <div class="right">
                <el-radio-group class="custom-tab" v-model="tab2Position" @change="part2Tab1">
                    <el-radio-button label="个人作品">个人作品</el-radio-button>
                    <el-radio-button label="商业作品">商业作品</el-radio-button>
                </el-radio-group>
            </div>
        </div>
        <div class="vodieContainer" v-loading="loading">
            <a class="card-item" v-for="item in videoData" :key="item.title" :href="item.url" target="_blank">
                <div class="left">
                    <img class="cover" :src="item.cover" :alt="item.title">
                    <span class="duration">{{ item.duration }}</span>
                </div>
                <div class="right">
                    <div class="title">
                        {{ item.title }}
                    </div>
                    <div class="info">
                        <div class="item"><img src="@/assets/images/play.png" alt=""><span>{{ item.play_cnt }}</span></div>
                        <div class="item"><img src="@/assets/images/like.png" alt=""><span>{{ item.like_cnt }}</span></div>
                        <div class="item"><img src="@/assets/images/comment.png" alt=""><span>{{ item.comment_cnt }}</span></div>
                    </div>
                    <div class="bottom">
                        发布时间：{{ item.pubDate }}
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>
<script>
import tools from "../../../components/tools/tools.js";
import { apiCache } from '@/utils/index.js';
export default {
    props: ['fatherDarenInfo'],
    data() {
        return {
            // 视频信息
            videoData:[],
            tab2Position:'个人作品',
            loading: false
        }
    },
    methods: {
        part2Tab1(val){
            this.tab2Position = val
            if(val==="个人作品"){
                this.fetchRepresentativeData('getRepresentative',1)
            }else if(val==="商业作品"){
                this.fetchRepresentativeData('getRepresentative',2)
            }
        },
        initRepresentative(val){
            this.videoData = val.map(item=>{
                item.play_cnt = tools.setW(item.play_cnt)
                item.like_cnt = tools.setW(item.like_cnt)
                item.comment_cnt = tools.setW(item.comment_cnt)
                item.url = 'https://www.bilibili.com/video/'+item.bv_id
                item.pubDate= this.dayjs(item.pub_time * 1000).format('YYYY-MM-DD')
                if(item.duration<60){
                item.duration = `0:${item.duration}`
                }else if(item.duration>=60&&item.duration<3600){
                item.duration = `${parseInt(item.duration/60)}:${item.duration%60}`
                }else if(item.duration>=3600){
                item.duration = `${parseInt(item.duration/3600)}:${parseInt((item.duration%3600)/60)}:${item.duration%60}`
                }
                return item
            })
        },
        async fetchRepresentativeData(key,type){
            try {
                this.loading = true
                const res = await apiCache(key+type,()=>this.$api.getBZhanData.getRepresentative(`?upper_mid=${this.$route.query.up_id}&type=${type}`))
                this.loading = false
                if(res.data.code!==0){return}
                this.initRepresentative(res.data.data)
            } catch (error) {
                console.log('error :>> ', error);
            }
        },
        initData(){
            this.fetchRepresentativeData('getRepresentative',1)
        }
    },
    created(){
        this.initData()
    }
};
</script>
<style lang='scss' scoped>

.vodieContainer{
    display:flex;
    flex-flow:row wrap;
    .card-item {
        display:flex;
        margin-right:12px;
        margin-bottom:12px;
        &:nth-of-type(2n){
            margin-right:0;
        }
        width:calc(50% - 6px);
        border-radius:4px;
        padding:12px;
        box-sizing:border-box;
        background-color:#f9f9fc;

        .left{
            position:relative;
            flex:0 0 230px;
            height:140px;
            margin-right:12px;
            .cover{
                width:100%;
                height:100%;
                display:block;
                border-radius:4px;
                object-fit:cover;
            }
            .duration{
                position:absolute;
                top:6px;
                right:6px;
                display:inline-block;
                padding:4px 8px;
                color:#fff;
                border-radius:4px;
                font-size:12px;
                background-color:rgba(0,0,0,0.6)
            }
        }
        .right{
            min-width:0;
            flex:1 1 auto;
            display:flex;
            flex-direction:column;
            .title{
                font-size: 16px;
                margin-top:10px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .info{
                margin-top:auto;
                margin-bottom:0;
                font-size:14px;
                display:flex;
                align-items:center;
                line-height:24px;
                img{
                    width:24px;
                    margin-right:6px;
                }
                span{
                    margin-right:12px;
                }
            }
            .bottom{
                margin-top:8px;
                margin-bottom:0;
                font-size:14px;
                height:24px;
                line-height:24px;
            }
        }
    }
}
</style>